import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "c360dd4c-caf9-4412-b81a-eaedfd0506ce",
    content:
      "Define a unique system of descriptors for the relevant components of indoor acoustic comfort, in relation to building acoustics, and harmonize their use across Europe and beyond.",
    options: {},
  },
  {
    id: "b5a1bc19-b57b-4154-823b-84942df8d34b",
    content:
      "Propose a unique classification system for the relevant components of indoor acoustic comfort, in relation to building acoustics.",
    options: {},
  },
  { id: "f47f151b-8079-4b1d-9de7-f79ae1d60858", content: "Both a) and b).", options: {} },
  { id: "d28b8d24-70bc-46c7-b84c-62751ff42bb4", content: "Neither a), nor b).", options: {} },
];

export const task: Task = {
  id: "0d288c09-370e-4bd5-9ff9-82b02e6f36d5",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 1,
    shuffle: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["f47f151b-8079-4b1d-9de7-f79ae1d60858"],
};
